export const MAJORS = [
  '기계공학전공(과)',
  '산업공학전공(과)',
  '화학공학전공(과)',
  '첨단신소재공학전공(과)',
  '응용화학생명공학전공(과)',
  '응용화학전공(과)',
  '환경안전공학전공(과)',
  '건설시스템공학전공(과)',
  '교통시스템공학전공(과)',
  '건축학전공(5년)(과)',
  '건축공학전공(과)',
  '융합시스템공학전공(과)',
  '전자공학전공(과)',
  '지능형반도체공학전공(과)',
  '사이버보안전공(과)',
  '미래모빌리티공학전공(과)',
  '미래반도체 연계전공(과)',
  '소프트웨어및컴퓨터공학전공(과)',
  '글로벌IT전공(과)',
  '디지털미디어전공(과)',
  '공군ICT전공(과)',
  '인공지능융합전공(과)',
  '수학전공(과)',
  '물리학전공(과)',
  '화학전공(과)',
  '생명과학전공(과)',
  '물리·양자과학전공(과)',
  '화학·물질과학전공(과)',
  '생명과학·응용생물학 전공(과)',
  '경영학전공(과)',
  '금융공학전공(과)',
  '글로벌경영학전공(과)',
  '국제경영전공(과)',
  '경영인텔리전스학전공(과)',
  '국어국문학전공(과)',
  '한국어문전공(과)',
  '영어영문학전공(과)',
  '불어불문학전공(과)',
  '사학전공(과)',
  '문화콘텐츠학전공(과)',
  '데이터인문 연계전공(과)',
  '경제학전공(과)',
  '행정학전공(과)',
  '심리학전공(과)',
  '사회학전공(과)',
  '정치외교학전공(과)',
  '스포츠레저학전공(과)',
  '경제분야전공(과)',
  '정치분야전공(과)',
  '사회분야전공(과)',
  '의학전공(과)',
  '간호학전공(과)',
  '간호학전공(특별과정)(과)',
  '약학전공(과)',
  '한국학전공(과)',
  '국제통상전공(과)',
  '문화산업과커뮤니케이션전공(과)',
  '중국지역연구전공(과)',
  '일본지역연구전공(과)',
  '인간·사회·규범 연계전공(과)',
  '의료인공지능',
  '혁신신약공학전공(과)',
  '바이오첨단소재공학전공(과)',
  'IT경영전공(과)'
];

